import axiosInstance from './AxiosInstance';

const API_URL = 'mtr';

export const getModuleToModuleToRoles = async () => {
    try {
        const response = await axiosInstance.get(API_URL);
        return response.data;
    } catch (error) {
        console.error('Error fetching modules to role', error);
        throw error;
    }
};

export const getModuleToRoleById = async (id) => {
    try {
        const response = await axiosInstance.get(`${API_URL}/view/${id}`);
        return response.data;
    } catch (error) {
        console.error(`Error fetching role with id ${id}`, error);
        throw error;
    }
};

export const createModuleToRole = async (mtr) => {
    try {
        const response = await axiosInstance.post(`${API_URL}/add`, mtr);
        return response.data;
    } catch (error) {
        console.error('Error creating modules to role', error);
        throw error;
    }
};

export const updateModuleToRole = async (id, mtr) => {
    try {
        const response = await axiosInstance.post(`${API_URL}/update`, { id: id, ...mtr });
        return response.data;
    } catch (error) {
        console.error(`Error updating modules to role with id ${id}`, error);
        throw error;
    }
};

export const deleteModuleToRole = async (id) => {
    try {
        const response = await axiosInstance.post(`${API_URL}/delete/`, { id: id });
        return response.data;
    } catch (error) {
        console.error(`Error deleting modules to role with id ${id}`, error);
        throw error;
    }
};

